import React from 'react';
import { useHistory } from 'react-router';
import { Box, Typography } from '@mui/material';
import { ROUTING_CONFIG } from '@uplift/constants';
import { useIsMobile, useL10n } from '@uplift/hooks';
import { useStyles } from './modal.styles';
import { Button, Modal, ModalActions, ModalContent } from '@uplift/ui-v2';

type UnableStartProps = {
  isOpen: boolean;
};

export const UnableStartSessionModal: React.FC<UnableStartProps> = ({
  isOpen,
}) => {
  const history = useHistory();
  const { classes } = useStyles();
  const l10n = useL10n();
  const isMobile = useIsMobile();

  return (
    <Modal
      open={isOpen}
      title={l10n.sessions.unableStartSession.title}
      disableBackdropClick
      disableEscapeKeyDown
      showCloseIcon={false}
    >
      <ModalContent>
        <Box mt={1} mb={1}>
          <Box>
            <Box>
              <Typography>
                {l10n.sessions.unableStartSession.descFirst}
              </Typography>
            </Box>
            <Box mt={4}>
              <Typography>
                {l10n.sessions.unableStartSession.descSecond}
              </Typography>
            </Box>
          </Box>
        </Box>
      </ModalContent>
      <ModalActions>
        <Button
          onClick={() => history.push(ROUTING_CONFIG.main)}
          className={classes.button}
          variant="contained"
          color="secondary"
          fullWidth={isMobile}
        >
          {l10n.general.dismiss}
        </Button>
      </ModalActions>
    </Modal>
  );
};
